// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2RZB6","inner":"Footer_inner___4161"};